import React, { useContext, useRef } from 'react';
import BookerContext from '../../context/bookerContext';
import fieldParams from '../../const/fieldParams';
import '../../assets/styles/fleets.sass';

const FleetsProvider = ({ fieldKey }) => {
  const { state, updateSelectedFleet, updatePayment, updatePaymentMethodId } = useContext(BookerContext);
  const { fleets, selectedFleet = {} } = state;
  const inputRef = useRef(null);
  const { id } = fieldParams[fieldKey];

  const handleChange = e => {
    updatePayment({});
    updatePaymentMethodId(null);

    const selectedOption = fleets.find(item => item.id === parseInt(inputRef.current?.value));
    updateSelectedFleet(selectedOption);
  };

  const fleetsList =
    fleets?.length > 0 &&
    fleets.map((item, i) => {
      return (
        <option
          key={item.key}
          value={item.id}
          data-name={item.name}
          data-multifleet={item.multifleet}
          className="fleets-option"
        >
          {item.name}
        </option>
      );
    });

  if (!selectedFleet || !selectedFleet.id) return <></>;

  return fleetsList.length > 1 ? (
    <div className="fleets-container">
      <div className="form-group form-group-fleet">
        <label htmlFor="fleet" className="form-label fleets-label">
          Providers
        </label>
        <div className="fleets">
          <select
            ref={inputRef}
            defaultValue={selectedFleet.name}
            id={id}
            value={selectedFleet.id}
            onChange={handleChange}
          >
            {fleetsList}
          </select>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default FleetsProvider;
